// extracted by mini-css-extract-plugin
module.exports = {"Partners":"_2ueIZZMd","Title":"_2ywdpH9s","Container":"_17gq9exN","LogosContainer":"_3Tmg_EHa","Logo":"QgV-777s","LogoModHealth":"_3drad5B1"};
    if(module.hot) {
      // 1754514932939
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  